import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Import Certificates
import Cer1 from "../image/Cer1.jpg";
import Cer2 from "../image/Cer2.jpg";
import Cer3 from "../image/Cer3.jpg";
import Cer4 from "../image/Cer4.jpg";
import Cer5 from "../image/Cer5.jpg";
import Cer6 from "../image/Cer6.jpg";
import Img1 from "../image/team/1.png";
import Img2 from "../image/team/2.png";
import Img4 from "../image/team/4.png";
import Img5 from "../image/team/5.png";
import Img6 from "../image/team/6.png";
import Img7 from "../image/team/7.png";
const Person7Img = "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=400&q=80";

const getTeamMembers = (t) => [
  {
    id: 1,
    ...t("team_page.members.vipada", { returnObjects: true }),
    image: Img1,
    certificates: []
  },
  {
    id: 2,
    ...t("team_page.members.kitti", { returnObjects: true }),
    image: Img2,
    certificates: []
  },
  {
    id: 4,
    ...t("team_page.members.rapeepan", { returnObjects: true }),
    image: Img4,
    certificates: []
  },
  {
    id: 5,
    ...t("team_page.members.akapol", { returnObjects: true }),
    image: Img5,
    certificates: []
  },
  {
    id: 6,
    ...t("team_page.members.somchai", { returnObjects: true }),
    image: Img6,
    certificates: []
  },
  {
    id: 7,
    ...t("team_page.members.khwanruethai", { returnObjects: true }),
    image: Img7,
    certificates: []
  },
];

export default function Team() {
  const { t } = useTranslation();
  const [isCtaHovered, setIsCtaHovered] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [activeCert, setActiveCert] = useState(null);

  const teamMembers = getTeamMembers(t);
  
  const openModal = (member) => {
    setSelectedMember(member);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedMember(null);
    setActiveCert(null);
    document.body.style.overflow = "auto";
  };

  return (
    <div style={{ 
      fontFamily: "'Prompt', sans-serif", 
      backgroundColor: "#ffffff", 
      minHeight: "100vh",
      position: "relative",
      overflowX: "hidden"
    }}>
      
      {/* Hero Section */}
      <section style={{ background: "linear-gradient(135deg, #0B1B3D 0%, #1a365d 100%)", color: "#ffffff", padding: "100px 20px 60px", textAlign: "center" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h1 style={{ fontSize: "42px", fontWeight: "700", marginBottom: "20px", color: "#D4AF37" }}>
            {t("team_page.hero_title")}
          </h1>
          <p style={{ fontSize: "18px", lineHeight: "1.6", color: "#e5e7eb" }}>
            {t("team_page.hero_desc")}
          </p>
        </div>
      </section>

      {/* Unified Team Section */}
      <section style={{ padding: "80px 20px", backgroundColor: "#ffffff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "50px" }}>
            <h2 style={{ fontSize: "32px", fontWeight: "600", color: "#111827", marginBottom: "10px" }}>
              {t("team_page.section_title")}
            </h2>
            <div style={{ width: "80px", height: "4px", backgroundColor: "#D4AF37", margin: "0 auto 20px" }}></div>
            <p style={{ fontSize: "16px", color: "#4b5563", maxWidth: "700px", margin: "0 auto" }}>
              {t("team_page.section_subtitle")}
            </p>
          </div>

          <div style={{ 
            display: "flex", flexWrap: "wrap", gap: "30px", justifyContent: "flex-start", 
            position: "relative", zIndex: 1 
          }}>
            {/* All Members */}
            {teamMembers.map((member) => (
              <TeamCard key={member.id} member={member} borderColor="#0B1B3D" onClick={() => openModal(member)} />
            ))}
            
            {/* Philosophy Card as the last item */}
            <div style={{
              width: "100%", maxWidth: "350px", minHeight: "550px",
              backgroundColor: "#0B1B3D", borderRadius: "12px", color: "#ffffff",
              display: "flex", flexDirection: "column", overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)", borderLeft: "5px solid #D4AF37",
              padding: "40px 30px", textAlign: "left"
            }}>
              <h3 style={{ color: "#D4AF37", fontSize: "24px", fontWeight: "700", marginBottom: "30px" }}>
                {t("team_page.philosophy.title")}
              </h3>
              
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: "17px", lineHeight: "1.9", opacity: 0.9, fontStyle: "italic", marginBottom: "30px", color: "#f3f4f6" }}>
                  "{t("team_page.philosophy.quote")}"
                </p>
                
                <div style={{ width: "60px", height: "3px", backgroundColor: "#D4AF37", marginBottom: "20px" }}></div>
                
                <p style={{ fontSize: "15px", fontWeight: "600", color: "#ffffff", opacity: 1 }}>
                  — {t("team_page.philosophy.author")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Detail Modal */}
      {selectedMember && (
        <div 
          style={{
            position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.75)", backdropFilter: "blur(8px)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1000, padding: "20px"
          }}
          onClick={closeModal}
        >
          <div 
            style={{
              backgroundColor: "#ffffff", width: "95%", maxWidth: "1400px",
              maxHeight: "95vh", borderRadius: "min(32px, 5vw)", overflow: "hidden",
              position: "relative", display: "flex", flexDirection: "column",
              boxShadow: "0 30px 100px -12px rgba(0, 0, 0, 0.7)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button 
              onClick={closeModal}
              style={{
                position: "absolute", top: "20px", right: "20px",
                width: "40px", height: "40px", borderRadius: "50%",
                backgroundColor: "#f3f4f6", border: "none", fontSize: "24px",
                cursor: "pointer", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center"
              }}
            >
              &times;
            </button>

            <div style={{ display: "flex", flexWrap: "wrap", overflowY: "auto" }}>
              {/* Left: Image & Role */}
              <div style={{ 
                flex: "1 1 500px", 
                backgroundColor: "#0B1B3D", 
                color: "#ffffff", 
                padding: "clamp(40px, 8vh, 80px) clamp(20px, 5%, 40px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}>
                <div style={{ 
                  width: "clamp(180px, 20vw, 300px)", 
                  height: "clamp(180px, 20vw, 300px)", 
                  borderRadius: "50%", 
                  overflow: "hidden", 
                  marginBottom: "35px", 
                  border: "clamp(4px, 1vw, 8px) solid #D4AF37", 
                  boxShadow: "0 15px 40px rgba(0,0,0,0.4)" 
                }}>
                  <img 
                    src={selectedMember.image} 
                    alt={selectedMember.name} 
                    onContextMenu={(e) => e.preventDefault()}
                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top", pointerEvents: "none", userSelect: "none" }} 
                  />
                </div>
                
                {/* Dynamic Font Sizing Logic */}
                <h3 style={{ 
                  fontSize: selectedMember.name.length > 30 ? "26px" : selectedMember.name.length > 22 ? "32px" : "40px", 
                  textAlign: "center", 
                  marginBottom: "15px", 
                  color: "#D4AF37", 
                  fontWeight: "800", 
                  lineHeight: "1.3",
                  wordBreak: "break-word",
                  width: "100%"
                }}>{selectedMember.name}</h3>
                
                <p style={{ textAlign: "center", fontSize: "clamp(18px, 2vw, 22px)", opacity: 0.9, marginBottom: "40px", fontWeight: "300" }}>{selectedMember.role}</p>
                
                <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: "30px", width: "100%" }}>
                  <strong style={{ 
                    display: "block", 
                    marginBottom: "15px", 
                    color: "#D4AF37", 
                    fontSize: "20px",
                    textTransform: "uppercase",
                    letterSpacing: "1px"
                  }}>{t("team_page.labels.expertise")}</strong>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                    {selectedMember.expertise.split(",").map((exp, index) => (
                      <span 
                        key={index}
                        style={{ 
                          backgroundColor: "rgba(212, 175, 55, 0.1)", 
                          padding: "10px 20px", 
                          borderRadius: "10px", 
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#D4AF37",
                          border: "1px solid rgba(212, 175, 55, 0.4)",
                          transition: "all 0.3s ease"
                        }}
                      >
                        {exp.trim()}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right: Bio & Certificates */}
              <div style={{ flex: "2 1 600px", padding: "clamp(30px, 6vw, 80px)", backgroundColor: "#ffffff" }}>
                <h4 style={{ fontSize: "clamp(22px, 2.5vw, 30px)", color: "#111827", marginBottom: "25px", display: "flex", alignItems: "center", gap: "15px" }}>
                  <span style={{ width: "6px", height: "clamp(24px, 3vw, 35px)", backgroundColor: "#D4AF37" }}></span>
                  {t("team_page.labels.bio_title")}
                </h4>
                <p style={{ fontSize: "clamp(16px, 1.8vw, 20px)", lineHeight: "1.8", color: "#4b5563", marginBottom: "30px" }}>
                  {selectedMember.fullBio}
                </p>



                    <div style={{ marginTop: "20px" }}>
                      <h4 style={{ fontSize: "clamp(22px, 2.5vw, 28px)", color: "#111827", marginBottom: "20px" }}>{t("team_page.labels.cert_title")}</h4>
                      <div 
                        className="cert-scroll-container"
                        style={{ 
                          display: "flex", 
                          flexWrap: "nowrap",
                          gap: "15px", 
                          overflowX: "auto", 
                          paddingBottom: "15px",
                          scrollbarWidth: "thin",
                          scrollbarColor: "#D4AF37 #f3f4f6",
                          width: "525px",
                          maxWidth: "100%"
                        }}
                      >
                        {selectedMember.certificates.map((cert) => (
                          <div
                            key={cert.id}
                            onClick={() => setActiveCert(cert)}
                            style={{
                              flex: "0 0 120px", 
                              height: "160px", 
                              cursor: "pointer",
                              border: "1px solid #e5e7eb", 
                              borderRadius: "8px", 
                              overflow: "hidden",
                              transition: "all 0.3s ease", 
                              boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                              flexShrink: 0
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                            onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                          >
                            <img 
                              src={cert.img} 
                              alt={cert.title} 
                              onContextMenu={(e) => e.preventDefault()}
                              style={{ width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none", userSelect: "none" }} 
                            />
                          </div>
                        ))}
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Certificate Lightbox */}
      {activeCert && (
        <div 
          style={{
            position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.95)", display: "flex", alignItems: "center", 
            justifyContent: "center", zIndex: 1100, padding: "20px"
          }}
          onClick={() => setActiveCert(null)}
        >
          <div style={{ maxWidth: "90%", maxHeight: "90vh", textAlign: "center" }}>
            <img 
              src={activeCert.img} 
              alt={activeCert.title} 
              onContextMenu={(e) => e.preventDefault()}
              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain", borderRadius: "8px", boxShadow: "0 0 50px rgba(212, 175, 55, 0.3)", pointerEvents: "none", userSelect: "none" }} 
            />
            <p style={{ color: "white", marginTop: "20px", fontSize: "18px" }}>{activeCert.title}</p>
          </div>
          <button style={{ position: "absolute", top: "30px", right: "30px", background: "none", border: "none", color: "white", fontSize: "40px", cursor: "pointer" }}>&times;</button>
        </div>
      )}
      
      {/* Premium Call to Action */}
      <section style={{ 
        padding: "100px 20px", 
        background: "linear-gradient(135deg, #0B1B3D 0%, #050d1d 100%)", 
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div style={{
          position: "absolute", top: "-50%", left: "-10%", width: "50%", height: "200%",
          background: "radial-gradient(circle, rgba(212, 175, 55, 0.05) 0%, transparent 70%)",
          zIndex: 0
        }}></div>
        
        <div style={{ position: "relative", zIndex: 1, maxWidth: "800px", margin: "0 auto" }}>
          <h3 style={{ fontSize: "36px", color: "#ffffff", marginBottom: "20px", fontWeight: "800" }}>
            {t("team_page.cta.title")}
          </h3>
          <p style={{ color: "#e5e7eb", fontSize: "18px", marginBottom: "40px", opacity: 0.9 }}>
            {t("team_page.cta.desc")}
          </p>
          
          <div style={{ display: "flex", gap: "20px", justifyContent: "center", flexWrap: "wrap" }}>
            <a 
              href="/contact" 
              style={{ 
                padding: "18px 45px", backgroundColor: "#D4AF37", color: "#0B1B3D", 
                fontSize: "18px", fontWeight: "800", textDecoration: "none", 
                borderRadius: "50px", transition: "0.3s", boxShadow: "0 10px 25px rgba(212, 175, 55, 0.3)"
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 15px 30px rgba(212, 175, 55, 0.5)" }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 10px 25px rgba(212, 175, 55, 0.3)" }}
            >
              {t("team_page.cta.btn")}
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}

/* Sub-component สำหรับการ์ดแสดงโปรไฟล์ทีมงาน */
function TeamCard({ member, borderColor, onClick }) {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ 
        width: "100%", 
        maxWidth: "350px", 
        backgroundColor: "#ffffff", 
        borderRadius: "12px", 
        overflow: "hidden", 
        cursor: "pointer",
        boxShadow: isHovered ? "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)" : "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
        borderTop: `5px solid ${borderColor}`,
        transform: isHovered ? "translateY(-10px)" : "translateY(0)",
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <div style={{ height: "350px", overflow: "hidden", position: "relative" }}>
        <img 
          src={member.image} 
          alt={member.name} 
          onContextMenu={(e) => e.preventDefault()}
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "cover", 
            objectPosition: "top",
            transform: isHovered ? "scale(1.08)" : "scale(1)",
            transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
            pointerEvents: "none",
            userSelect: "none"
          }} 
        />
        {/* Overlay showing "Click to View Details" */}
        <div style={{
          position: "absolute",
          top: 0, left: 0, width: "100%", height: "100%",
          backgroundColor: "rgba(11, 27, 61, 0.4)",
          display: "flex", alignItems: "center", justifyContent: "center",
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.3s ease"
        }}>
          <span style={{ color: "white", padding: "8px 20px", border: "2px solid white", borderRadius: "20px", fontSize: "14px", fontWeight: "600" }}>{t("team_page.view_details")}</span>
        </div>
      </div>
      <div style={{ padding: "25px" }}>
        <h3 style={{ fontSize: "22px", fontWeight: "600", color: "#111827", marginBottom: "5px", minHeight: "66px", display: "flex", alignItems: "center" }}>
          <span dangerouslySetInnerHTML={{ __html: member.name.replace(/ สหเกียรติมนตรี/, "<br/>สหเกียรติมนตรี") }} />
        </h3>
        <div style={{ fontSize: "14px", fontWeight: "500", color: "#D4AF37", marginBottom: "15px", minHeight: "42px" }}>
          {member.role}
        </div>
        
        
        
        <div style={{ marginBottom: "15px" }}>
          <strong style={{ fontSize: "14px", color: "#374151" }}>{t("team_page.labels.expertise")}</strong>
          <p style={{ fontSize: "14px", color: "#6b7280", margin: "5px 0 0" }}>
            {member.expertise}
          </p>
        </div>
        
        <div>
          <strong style={{ fontSize: "14px", color: "#374151" }}>{t("team_page.labels.experience")}</strong>
          <p style={{ fontSize: "14px", color: "#6b7280", margin: "5px 0 0", lineHeight: "1.5" }}>
            {member.experience}
          </p>
        </div>
      </div>
    </div>
  );
}